import styled from '@emotion/styled';
import { Button, Tooltip } from 'antd';
import EditorPreviewer from 'components/EditorPreviewer';
import { mustache2SlateValueWithCatch } from 'components/TemplateEditor/mustacheUtils';
import { HTMLAttributes, memo } from 'react';
import { useTranslate } from '@tolgee/react';
import { Descendant } from 'slate';
import { ResultText } from '../BilingualExecuteContextField';
import { Question } from '../share';

const Container = styled.div`
  border: solid 1px var(--fett-border-default);
  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px var(--fett-border-default);
    > h5 {
      display: flex;
      align-items: center;
      position: relative;
      left: 16px;
      margin-bottom: 0;
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 2px;
        left: -8px;
        width: 4px;
        height: 14px;
        background: #3370ff;
      }
    }
  }
`;

const PreviewWrapper = styled.div`
  padding: 0 8px;
  > div {
    padding: 8px 0;
    & + div {
      border-top: dashed 1px var(--fett-border-default);
    }
  }
  > div > div {
    height: auto;
  }
`;

export interface RecommendContent {
  tag: string;
  description?: string;
  replyTemplate: string;
}

export type LangRecommendTemplateMap = Partial<Record<General.Language, RecommendContent>>;

export interface RecommendTemplateProps extends HTMLAttributes<HTMLDivElement> {
  regionData: RecommendContent;
  systemData: RecommendContent;
  onTemplateSelect: (template: Descendant[]) => void;
}

export const RecommendTemplate = memo((props: RecommendTemplateProps) => {
  const { regionData, systemData, onTemplateSelect, ...otherProps } = props;

  const { t } = useTranslate();

  const { tag, description, replyTemplate: systemMustacheTemplate } = systemData;

  const { replyTemplate: regionMustacheTemplate } = regionData;

  const systemTemplate = mustache2SlateValueWithCatch(
    systemMustacheTemplate.replace(/^#mustache#/, ''),
  );

  const regionTemplate = mustache2SlateValueWithCatch(
    regionMustacheTemplate.replace(/^#mustache#/, ''),
  );

  if (!systemTemplate || !regionTemplate) {
    return null;
  }

  return (
    <Container {...otherProps}>
      <header>
        <h5>
          {tag}
          {description && (
            <Tooltip title={description}>
              <Question />
            </Tooltip>
          )}
        </h5>
        <Button type="link" onClick={() => onTemplateSelect(regionTemplate)}>
          {t('aide.选择')}
        </Button>
      </header>
      <PreviewWrapper>
        <ResultText>
          <EditorPreviewer value={regionTemplate} />
        </ResultText>
        {systemMustacheTemplate !== regionMustacheTemplate && (
          <ResultText>
            <EditorPreviewer value={systemTemplate} />
          </ResultText>
        )}
      </PreviewWrapper>
    </Container>
  );
});
